export default "__VITE_ASSET__BUO$cTug__"